import intl from "components/i18n/ReactIntlWrapper";
import ErrorSummary from '../../../components/common/ErrorSummary';
import {
  Box,
  Grid,
  FormControl,
  FormLabel,
  Switch,
  Typography,
  TextField,
} from '@mui/material';
import CountrySelect from '../../common/Selects/CountrySelect';

const CorporateEntityForm = ({ errors, input, handleInputChange, disabled, handleStatusChange, countries, handleCountryChange }) => {

    return (
        <Box component="form">
          <Grid container spacing={2} alignItems="flex-end">
            <Grid size={{ xs: 12, md: 4 }}>
              <FormControl fullWidth>
                <FormLabel sx={{ mb: 1 }}>{intl.get('statusSelect.label')}</FormLabel>
                <Box display="flex" alignItems="center" height={40}>
                  <Switch
                    checked={input.active}
                    onChange={handleStatusChange}
                    disabled={disabled}
                    size="small"
                  />
                  <Typography sx={{ ml: 1 }}>
                    {input.active
                      ? intl.get('roleRow.active')
                      : intl.get('roleRow.inactive')}
                  </Typography>
                </Box>
              </FormControl>
            </Grid>
                    
            <Grid size={{ xs: 12, md: 4 }}>
              <FormControl fullWidth error={Boolean(errors.name)}>
                <FormLabel>* {intl.get('corporateEntity.fantasyName')}</FormLabel>
                {errors.name && (
                  <Typography variant="caption" color="error">
                    {errors.name}
                  </Typography>
                )}
                <Typography variant="body2" fontStyle="italic" sx={{ mb: 1 }}>
                  {intl.get('corporateEntity.fantasyNamePurpose')}
                </Typography>
                <TextField
                  id="companyFantasyName"
                  name="name"
                  value={input?.name}
                  onChange={handleInputChange}
                  disabled={disabled}
                  fullWidth
                  error={Boolean(errors.name)}
                  variant="outlined"
                  size="small"
                  sx={{ height: 40 }}
                />
              </FormControl>
            </Grid>
            
            <Grid size={{ xs: 12, md: 4 }}>
              <FormControl fullWidth error={Boolean(errors.idCountry)}>
                <FormLabel sx={{ mb: 1 }}>
                  {intl.get('addressForm.country')}
                </FormLabel>
                {errors.idCountry && (
                  <Typography variant="caption" color="error">
                    {errors.idCountry}
                  </Typography>
                )}
                <Box mt={0}>
                  <CountrySelect
                    handleCountryChange={handleCountryChange}
                    selectedCountry={input.country.labelKey}
                    countries={countries}
                    inputCountry={input.country.name}
                  />
                </Box>
              </FormControl>
            </Grid>
          </Grid>
        </Box>

    )
}

export default CorporateEntityForm;